import { NgForOf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AyaSchoolsByCountryTable } from '../../models';
import { CompanyEnum } from '../../models/company.model';
import { AyaSchoolTableComponent } from '../aya-school-table/aya-school-table.component';
import { AyaSchoolHeaderComponent } from '../aya-school-header/aya-school-header.component';

@Component({
  standalone: true,
  selector: 'lx-price-lists-portal-aya-countries-school-list',
  templateUrl: './aya-countries-school-list.component.html',
  styleUrls: ['./aya-countries-school-list.component.scss', './print-aya-countries-school-list.component.scss'],
  imports: [AyaSchoolTableComponent, NgForOf, AyaSchoolHeaderComponent],
})
export class AyaCountriesSchoolListComponent {
  @Input() schoolTables: AyaSchoolsByCountryTable[] | undefined;
  protected readonly CompanyEnum = CompanyEnum;
}
